if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      if(document.querySelector("model-viewer")){
        document.querySelector("model-viewer").classList.remove("shopify-model-viewer-ui__disabled"); 
      }
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      this.productZoomSlider();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  
   productZoomSlider(){
    var productGalleryContainer = this.querySelector(".product-gallery");
    
      var images =  productGalleryContainer.querySelectorAll(".slidermedia");
      var imageArray = Array.from(images);

      var svgArrow = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-submit" viewBox="0 0 1024 1024"><path d="M1023.998 511.724v-6.44a4.818 4.818 0 00-1.605-3.215l-.005-.005c0-1.61-1.61-1.61-1.61-3.22s-1.61-1.61-1.61-3.22c-.89 0-1.61-.72-1.61-1.61L652.074 115.649c-6.058-5.789-14.286-9.354-23.346-9.354s-17.288 3.564-23.358 9.366l.013-.013c-6.101 5.61-9.909 13.631-9.909 22.541s3.81 16.931 9.888 22.52l.022.02 307.522 318.793H32.201C14.416 479.522 0 493.939 0 511.723s14.417 32.201 32.201 32.201h887.145L605.384 862.717a32.062 32.062 0 00-8.429 21.72c0 9.19 3.851 17.481 10.025 23.347l.014.013c5.61 6.101 13.631 9.909 22.541 9.909s16.931-3.81 22.52-9.888l.02-.022 363.874-370.315c0-1.61 0-1.61 1.61-3.22.89 0 1.61-.72 1.61-1.61 0-1.61 1.61-1.61 1.61-3.22h1.61v-3.22a4.81 4.81 0 001.608-3.203l.002-.017v-11.27z"></path></svg>'

      var prevButton = productGalleryContainer.parentElement.querySelector(".prev");
      prevButton.addEventListener("click", (e) => {
        e.preventDefault();
        var activeImage = productGalleryContainer.querySelector(".active");
        let currentIndex = [...activeImage.parentNode.children].indexOf(activeImage);

        if (currentIndex === 0) {
          currentIndex = images.length;
        }
        images.forEach((image, index) => {
          image.classList.toggle("active", index === currentIndex - 1);
        });
      });

      var nextButton = productGalleryContainer.parentElement.querySelector(".next");
      nextButton.addEventListener("click", (e) => {
        e.preventDefault();
        var activeImage = productGalleryContainer.querySelector(".active");
        let currentIndex = [...activeImage.parentNode.children].indexOf(activeImage);

        if (currentIndex + 1 === images.length) {
          currentIndex = -1
        }
        images.forEach((image, index) => {
          image.classList.toggle("active", index === currentIndex + 1);
        });
      });

      productGalleryContainer.querySelectorAll('.slidermedia').forEach((item) => {
        item.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          // console.log(e.target);
          e.target.classList.toggle('slidermediaclick');
          if(e.target.classList.contains('slidermediaclick')){
            e.target.style.maxHeight = e.target.getAttribute('height') +"px";
          }else{
            e.target.style.maxHeight = "100vh";
          }
        });
      });

      images[0].classList.add("active");
      productGalleryContainer.classList.add("initialized");
    }
  });
}
